let auth_routes = [
  {
    path: '/auth',
    component: () => import('Modules/Auth/resources/layout/AuthLayout.vue'),
    meta: {isPublicRoute: true},
    children: [
      { path: '', name: 'auth', redirect: {name: 'login'}},
      { path: 'login', name: 'login', component: () => import('./pages/Login.vue') },
      { path: 'register', name:'register', component: () => import('./pages/Register.vue') },
      { path: 'forgot', name:'forgot', component: () => import('./pages/Forgot.vue') },
      { path: 'country', name:'set-country', component: () => import('./pages/Country.vue') },
      { path: 'forgot/verify', name:'forgot.verify', component: () => import('./pages/Verify.vue'), props: true }
    ]
  }
];

export default auth_routes;
